import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseInterface } from 'src/app/shared/interfaces/BaseInterface';
import { DevelopmentInterface } from 'src/app/shared/interfaces/DevelopmentInterface';

@Component({
  selector: 'app-modal-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateComponent implements OnInit {
  public developmentFormGroup: FormGroup;

  @Input() public title: string;
  @Input() private selectedDevelopment: DevelopmentInterface;
  @Output() private emitCloseService = new EventEmitter<boolean>();
  @Output() private emitDismissService = new EventEmitter<boolean>();
  @Output() private emitUpdateService = new EventEmitter<BaseInterface>();

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.createDevelopmentFormGroup();
  }

  private createDevelopmentFormGroup(): void {
    this.developmentFormGroup = this.formBuilder.group({
      name: [this.selectedDevelopment.titulo, [Validators.required]],
      description: [this.selectedDevelopment.informacion_extra, []],
    });
  }

  public onClose(): void {
    this.emitCloseService.emit(true);
  }

  public onDismiss(): void {
    this.emitDismissService.emit();
  }

  public createBody(): BaseInterface {
    return {
      name: this.developmentFormGroup.get('name').value,
      description: this.developmentFormGroup.get('description').value,
    };
  }

  public updateDevelopment(): void {
    if (this.developmentFormGroup.valid) {
      this.emitUpdateService.emit(this.createBody());
      this.emitCloseService.emit(true);
    }
  }
}
